module.exports = __webpack_public_path__ + "src/assets/img/4_8art_1part.e260a04b.jpg";